import Api from "utils/api/Api";

export const getUser = (params)=>Api.get(`/api/user/${params.queryKey[1]}`);